// slide cart function
// new quantity action for mini-cart
class QuantityInputAction extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  connectedCallback() {
    this.validateQtyRules();
  }

  onInputChange(event) {
    this.validateQtyRules();

    var variant_id = this.input.dataset.variant;
    var updates = {};
    updates[variant_id] = this.input.value;
    var formData = {updates};
    this.updateQty(formData);

  }
  
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) { 
      this.input.dispatchEvent(this.changeEvent);
          
    }
  }
  async updateQty(formData){
    toggleSpiner(true);
    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(response => {
      return response.json().then(function(cart) {
        Alpine.store('cart', cart);
      });
    }).catch((error) => {
      console.error('Error:', error);
      return false;
    });

    updateCartStore();
  }
  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    } 
  }
} 
customElements.define('quantity-input-action', QuantityInputAction);

function removeItemFromCart(event) {
  event.preventDefault();

  var updates = {};
  console.log(event.target);
  var variant_id = event.target.dataset.id;
  updates[variant_id] = 0;
  var formData = {updates};
  
  toggleSpiner(true);
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  }).then(response => {
    return response.json().then(function(cart) {
      Alpine.store('cart', cart);
      calculateProgress();
      checkExestingGiftsInCart();
      extractFreeProductsInCart();

      document.dispatchEvent(
        new CustomEvent("cartupdate", {
          bubbles: false,
          detail: { cart: cart },
        }),
      );
    });
  }).catch((error) => {
    console.error('Error:', error);
  });
}

function checkExestingGiftsInCart() {
  // step3
  if (cartPromoConditions.step3.type == 'product') {
    if (checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN1.productId)) {
      cartPromoConditions.step3.offerInCart = true;
      cartPromoConditions.step3.offerPos = 1;
    } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN2.productId)) {
      cartPromoConditions.step3.offerInCart = true;
      cartPromoConditions.step3.offerPos = 2;
    } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN3.productId)) {
      cartPromoConditions.step3.offerInCart = true;
      cartPromoConditions.step3.offerPos = 3;
    } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN4.productId)) {
      cartPromoConditions.step3.offerInCart = true;
      cartPromoConditions.step3.offerPos = 4;
    } else {
      cartPromoConditions.step3.offerInCart = false;
      cartPromoConditions.step3.offerPos = false;
    }
  }
  // step2 
  if (cartPromoConditions.step2.type == 'product') {
    // check if gift already in cart 
    if (checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN1.productId)) {
      cartPromoConditions.step2.offerInCart = true;
      cartPromoConditions.step2.offerPos = 1;
    } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN2.productId)) {
      cartPromoConditions.step2.offerInCart = true;
      cartPromoConditions.step2.offerPos = 2;
    } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN3.productId)) {
      cartPromoConditions.step2.offerInCart = true;
      cartPromoConditions.step2.offerPos = 3;
    } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN4.productId)) {
      cartPromoConditions.step2.offerInCart = true;
      cartPromoConditions.step2.offerPos = 4;
    } else {
      cartPromoConditions.step2.offerInCart = false;
      cartPromoConditions.step2.offerPos = false;
    }
  }
  // step1
  if (cartPromoConditions.step1.type == 'product') {
    // check if gift already in cart 
    if (checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN1.productId)) {
      cartPromoConditions.step1.offerInCart = true;
      cartPromoConditions.step1.offerPos = 1;
    } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN2.productId)) {
      cartPromoConditions.step1.offerInCart = true;
      cartPromoConditions.step1.offerPos = 2;
    } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN3.productId)) {
      cartPromoConditions.step1.offerInCart = true;
      cartPromoConditions.step1.offerPos = 3;
    } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN4.productId)) {
      cartPromoConditions.step1.offerInCart = true;
      cartPromoConditions.step1.offerPos = 4;
    } else {
      cartPromoConditions.step1.offerInCart = false;
      cartPromoConditions.step1.offerPos = false;
    }
  }
}

async function calculateProgress() {
  var nb_steps = 0;
  var max_cart_price = cartPromoConditions.step1.price;

  if (cartPromoConditions.step1.enabled) {
    nb_steps++;
  } 
  if (cartPromoConditions.step2.enabled) {
    nb_steps++;
    max_cart_price = cartPromoConditions.step2.price;
  } 
  if (cartPromoConditions.step3.enabled) {
    nb_steps++;
    max_cart_price = cartPromoConditions.step3.price;
  } 

  var cart_price = Alpine.store('cart').original_total_price/100;
  var value_step = 100/nb_steps;
  var cart_level = 0; 
  var amount_left = cartPromoConditions.step1.price - cart_price; 
  var progress_level = Math.round((cart_price / max_cart_price) * value_step);  
  var progress_message = cartPromoConditions.step1.message;  

  if (cartPromoConditions.step3.enabled && cart_price >= cartPromoConditions.step3.price) {
    cart_level = 3; 
    amount_left = cartPromoConditions.step3.price - cart_price; 
    progress_level = (cart_price / cartPromoConditions.step3.price) * 100; 
    progress_message = cartPromoConditions.step3.message;
    
    // apply gift based on the progress of cart
    await addGiftForStep1();
    await addGiftForStep2();
    await addGiftForStep3();
  } else if (cartPromoConditions.step2.enabled && cart_price >= cartPromoConditions.step2.price) {
    cart_level = 2; 
    progress_level = Math.round((cart_price / max_cart_price) * (value_step * cart_level)); 
    amount_left = cartPromoConditions.step2.price - cart_price; 
    progress_message = cartPromoConditions.step2.message;
    
    if (nb_steps > 2) {
      if (cart_price > cartPromoConditions.step2.price || cart_price == cartPromoConditions.step2.price) {
        amount_left = max_cart_price - cart_price;
        progress_message = cartPromoConditions.step3.message; 
        progress_level += (cart_price > cartPromoConditions.step2.price)? 10 : 4 ;
      }
    } else if (nb_steps == 2){
      amount_left = 0;
    }

    // if downgreaded step then delet old goodie
    if (Alpine.store('progressBar').cart_level > cart_level) {
      await removeOldStepGoodie(Alpine.store('progressBar').cart_level);
    }

    await addGiftForStep1();
    await addGiftForStep2();
  } else if (cartPromoConditions.step1.enabled && cart_price >= cartPromoConditions.step1.price) {
    cart_level = 1; 
    progress_level = Math.round((cart_price / max_cart_price) * (value_step * cart_level)); 
    progress_message = cartPromoConditions.step1.message;
    
    if (nb_steps > 1) {
      if (cart_price > cartPromoConditions.step1.price || cart_price == cartPromoConditions.step1.price) {
        amount_left = cartPromoConditions.step2.price - cart_price; 
        progress_message = cartPromoConditions.step2.message;
        if (nb_steps == 3) {
          progress_level += (cart_price > cartPromoConditions.step1.price)? (cartPromoConditions.step2.price - cartPromoConditions.step1.price - amount_left) : 4 ;
        } else {
          progress_level += (cart_price > cartPromoConditions.step1.price)? 15 : 4 ;
        }
      }
    }

    // if downgreaded step then delet old goodie
    if (Alpine.store('progressBar').cart_level > cart_level) {
      var nb_loops = Alpine.store('progressBar').cart_level - cart_level;
      for (var index = 0; index < nb_loops; index++) {
        await removeOldStepGoodie(Alpine.store('progressBar').cart_level - index);
      }
    }
    await addGiftForStep1();
  }

  if (cart_level == 0 && cart_price == 0 && Alpine.store('cart').item_count >= 0) {
    await clearCart();
  } else if (Alpine.store('progressBar').cart_level > cart_level) {
    var nb_loops = Alpine.store('progressBar').cart_level - cart_level;
    for (var index = 0; index < nb_loops; index++) {
      await removeOldStepGoodie(Alpine.store('progressBar').cart_level - index);
    }
  }

  Alpine.store('progressBar', {
    cart_price: cart_price,
    cart_level: cart_level,
    amount_left: amount_left,
    progress_level: progress_level,
    progress_message: progress_message,
    formated_progress_level: "width: "+progress_level+"%",
    nb_steps: nb_steps
  });
}

function extractFreeProductsInCart() {
  var freeProducts = { items: [] };
  var step1_productID = 0;
  var step2_productID = 0;
  var step3_productID = 0;


  if (Alpine.store('cart').item_count > 0) {
    if (cartPromoConditions.step3.offerInCart) {
      step3_productID = cartPromoConditions.step3.gift.offerN1.productId;

      if (cartPromoConditions.step3.offerPos == 4) {
        step3_productID = cartPromoConditions.step3.gift.offerN4.productId;
      } else if(cartPromoConditions.step3.offerPos == 3) {
        step3_productID = cartPromoConditions.step3.gift.offerN3.productId;
      } else if(cartPromoConditions.step3.offerPos == 2) {
        step3_productID = cartPromoConditions.step3.gift.offerN2.productId;
      }
    }

    if (cartPromoConditions.step2.offerInCart) {
      step2_productID = cartPromoConditions.step2.gift.offerN1.productId;

      if (cartPromoConditions.step2.offerPos == 4) {
        step2_productID = cartPromoConditions.step2.gift.offerN4.productId;
      } else if(cartPromoConditions.step2.offerPos == 3) {
        step2_productID = cartPromoConditions.step2.gift.offerN3.productId;
      } else if(cartPromoConditions.step2.offerPos == 2) {
        step2_productID = cartPromoConditions.step2.gift.offerN2.productId;
      }
    }

    if (cartPromoConditions.step1.offerInCart) {
      step1_productID = cartPromoConditions.step1.gift.offerN1.productId;

      if (cartPromoConditions.step1.offerPos == 4) {
        step1_productID = cartPromoConditions.step1.gift.offerN4.productId;
      } else if(cartPromoConditions.step1.offerPos == 3) {
        step1_productID = cartPromoConditions.step1.gift.offerN3.productId;
      } else if(cartPromoConditions.step1.offerPos == 2) {
        step1_productID = cartPromoConditions.step1.gift.offerN2.productId;
      }
    }

    Alpine.store('cart').items.forEach((item, index) => {
      if (item.id == step1_productID) {
        item.step = 1;
        freeProducts.items.push(item);
      } else if(item.id == step2_productID) {
        item.step = 2;
        freeProducts.items.push(item);
      } else if (item.id == step3_productID) {
        item.step = 3;
        freeProducts.items.push(item);
      }
    });
  }
  Alpine.store('freeProducts', freeProducts);
}

function removeGoodiesNotInOfferByStep(step = 1) {
  if (step == 3) { 
    if (cartPromoConditions.step3.offerPos == 4) {
      if (checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN3.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN3.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN2.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN2.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN1.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN1.productId);
      }
    } else if (cartPromoConditions.step3.offerPos == 3) {
      if (checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN4.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN4.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN2.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN2.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN1.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN1.productId);
      }
    } else if (cartPromoConditions.step3.offerPos == 2) {
      if (checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN4.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN4.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN3.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN3.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN1.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN1.productId);
      }
    } else if (cartPromoConditions.step3.offerPos == 1) {
      if (checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN3.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN3.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN2.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN2.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN4.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN4.productId);
      }
    }
  } else if (step == 2) {
    if (cartPromoConditions.step2.offerPos == 4) {
      if (checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN3.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN3.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN2.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN2.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN1.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN1.productId);
      }
    } else if (cartPromoConditions.step2.offerPos == 3) {
      if (checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN4.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN4.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN2.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN2.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN1.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN1.productId);
      }
    } else if (cartPromoConditions.step2.offerPos == 2) {
      if (checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN4.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN4.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN3.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN3.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN1.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN1.productId);
      }
    } else if (cartPromoConditions.step2.offerPos == 1) {
      if (checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN3.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN3.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN2.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN2.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN4.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN4.productId);
      }
    }
  } else if (step == 1) {
    if (cartPromoConditions.step1.offerPos == 4) {
      if (checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN3.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN3.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN2.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN2.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN1.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN1.productId);
      }
    } else if (cartPromoConditions.step1.offerPos == 3) {
      if (checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN4.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN4.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN2.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN2.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN1.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN1.productId);
      }
    } else if (cartPromoConditions.step1.offerPos == 2) {
      if (checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN4.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN4.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN3.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN3.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN1.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN1.productId);
      }
    } else if (cartPromoConditions.step1.offerPos == 1) {
      if (checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN3.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN3.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN2.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN2.productId);
      } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN4.productId)) {
        removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN4.productId);
      }
    }
  }
}

// function checkAndRemoveDuplicatedGoodies() {
//   console.log("checkAndRemoveDuplicatedGoodies!!");
//   if (Alpine.store('cart').item_count > 0) { 
//     if (cartPromoConditions.step3.offerInCart) {
//       removeGoodiesNotInOfferByStep(3);
//     }
//     if (cartPromoConditions.step2.offerInCart) {
//       removeGoodiesNotInOfferByStep(2);
//     }
//     if (cartPromoConditions.step1.offerInCart) {
//       removeGoodiesNotInOfferByStep(1);
//     }
//   }
// }

document.addEventListener("DOMContentLoaded", (event) => {
  document.addEventListener('cartupdate', (e) => { 
    setTimeout(() => {
      fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        return response.json().then(function(cart) {
          if(cart.items.length == 1 && cartPromoConditions.gift_wraps_in_cart > 0) {
            Shopify.Cart.GiftWrap.remove();
          }
          Alpine.store('cart', cart);
          checkExestingGiftsInCart();
          calculateProgress();
          refreshStorewithStorageData();
          extractFreeProductsInCart();
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }, 300);

    setTimeout(() => {
      toggleSpiner(false);
    }, 300);
  });
});

/** Trigger event cartupdate after 1000ms to prevent duplicated goodies and refresh calculations */
function triggerFetcher(flag = true) {
  var event_refresh = setInterval(function() {
    toggleSpiner(true);
    console.log("event triggred!!!!");
    document.dispatchEvent(
      new CustomEvent("cartupdate", {
        bubbles: false,
        detail: { cart: Alpine.store('cart') },
      }),
    );
  }, 10000);
  
  if (!flag) {
    clearInterval(event_refresh);
  }
}

function addGiftedProductBasedOnStep(productId) {
  if (productId == '') return;
  // add product to cart then apply promocode
  var formData = {
    'items': [{
      'id': productId,
      'quantity': 1
    }]
  };

  return fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json().then(function(json) {
      return json;
    });
  })
  .catch((error) => {
    console.error('Error:', error);
  });

}

function removeGiftedProductBasedOnStep(productId) {  
  if (productId == '') return;
  // add product to cart then apply promocode
  var updates = {};
  updates[productId] = 0;

  var formData = {updates};

  return fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json().then(function(json) {
      return json;
    });
  })
  .catch((error) => {
    console.error('Error:', error);
    return error;
  });
}

async function changeGiftedProduct(productId, step, offerNumber) {
  if (productId == '' || step == '' || offerNumber == '') return;
  closeSecondLayer(); 
  if (step == 1) {
    if (cartPromoConditions.step1.gift) {
      toggleSpiner(true);
      var step2_c =  localStorage.getItem('step2IsCanceled') == 'true'? true : false;
      var step3_c =  localStorage.getItem('step3IsCanceled') == 'true'? true : false;
      if (cartPromoConditions.step1.offerPos) {
        switch (cartPromoConditions.step1.offerPos) {
          case 1:
            await removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN1.productId);
            break;
          case 2:
            await removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN2.productId);
            break;
          case 3:
            await removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN3.productId);
            break;
          case 4:
            await removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN4.productId);
            break;
          default:
            console.log(`Sorry, no offer in cart yet!!`);
        } 
      }
    
      // setTimeout(() => {
      await addGiftedProductBasedOnStep(productId);
      // }, 300);

      cartPromoConditions.step1.offerInCart = true;
      cartPromoConditions.step1.offerPos = offerNumber;

      localStorage.setItem('step1IsCanceled', false);

      Alpine.store('canceledGiftsInCart', {
        step1: false,
        step2: step2_c,
        step3: step3_c
      });

      // setTimeout(() => {
        // toggleSpiner(false);
        document.dispatchEvent(
          new CustomEvent("cartupdate", {
            bubbles: false,
            detail: { cart: Alpine.store('cart') },
          }),
        );
      // }, 300);
    }
  } else if(step == 2) {
    if (cartPromoConditions.step2.gift) {
      toggleSpiner(true);
      var step1_c =  localStorage.getItem('step1IsCanceled') == 'true'? true : false;
      var step3_c =  localStorage.getItem('step3IsCanceled') == 'true'? true : false;
      if (cartPromoConditions.step2.offerPos){
        switch (cartPromoConditions.step2.offerPos) {
          case 1:
            await removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN1.productId);
            break;
          case 2:
            await removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN2.productId);
            break;
          case 3:
            await removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN3.productId);
            break;
          case 4:
            await removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN4.productId);
            break;
          default:
            console.log(`Sorry, no offer in cart yet!!`);
        } 
      }

      // setTimeout(() => {
      await addGiftedProductBasedOnStep(productId);
      // }, 300);
        
      cartPromoConditions.step2.offerInCart = true;
      cartPromoConditions.step2.offerPos = offerNumber;
    
      localStorage.setItem('step2IsCanceled', false);

      Alpine.store('canceledGiftsInCart', {
        step1: step1_c,
        step2: false,
        step3: step3_c
      });

      // setTimeout(() => {
        // toggleSpiner(false);
        document.dispatchEvent(
          new CustomEvent("cartupdate", {
            bubbles: false,
            detail: { cart: Alpine.store('cart') },
          }),
        );
      // }, 300);
    }
  } else if(step == 3) {
    if (cartPromoConditions.step3.gift) {
      toggleSpiner(true);
      var step1_c =  localStorage.getItem('step1IsCanceled') == 'true'? true : false;
      var step2_c =  localStorage.getItem('step2IsCanceled') == 'true'? true : false;
      if (cartPromoConditions.step3.offerPos){
        switch (cartPromoConditions.step3.offerPos) {
          case 1:
            await removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN1.productId);
            break;
          case 2:
            await removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN2.productId);
            break;
          case 3:
            await removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN3.productId);
            break;
          case 4:
            await removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN4.productId);
            break;
          default:
            console.log(`Sorry, no offer in cart yet!!`);
        } 
      }
      
      // setTimeout(() => {
      await addGiftedProductBasedOnStep(productId);
      // }, 300);
        
      cartPromoConditions.step3.offerInCart = true;
      cartPromoConditions.step3.offerPos = offerNumber;
      
      localStorage.setItem('step3IsCanceled', false);

      Alpine.store('canceledGiftsInCart', {
        step1: step1_c,
        step2: step2_c,
        step3: false
      });

      // setTimeout(() => {
        // toggleSpiner(false);
        document.dispatchEvent(
          new CustomEvent("cartupdate", {
            bubbles: false,
            detail: { cart: Alpine.store('cart') },
          }),
        );
      // }, 300);
    }
  } 
}

function checkIfProductExistInCartAsGift(productId) {
  if (productId == '') return false;
  var matched = false; 
  Alpine.store('cart').items.forEach((item, index) => {
    if (item.id == productId) {
      matched = true;
    } 
  });

  return matched;
}

// remove old step promo code and gift from cart
async function removeOldStepGoodie(oldStep) {
  if (oldStep == '') return;
  canceledGifts = Alpine.store('canceledGiftsInCart');

  if (oldStep == 1) {
    if (cartPromoConditions.step1.offerPos) {
      switch (cartPromoConditions.step1.offerPos) {
        case 1:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN1.productId);
          break;
        case 2:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN2.productId);
          break;
        case 3:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN3.productId);
          break;
        case 4:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN4.productId);
          break;
        default:
          console.log(`Sorry, no offer in cart yet!!`);
      } 
    }
    canceledGifts.step1 = false; 
    localStorage.setItem('step1IsCanceled', false);
  } else if (oldStep == 2) {
    if (cartPromoConditions.step2.offerPos) {
      switch (cartPromoConditions.step2.offerPos) {
        case 1:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN1.productId);
          break;
        case 2:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN2.productId);
          break;
        case 3:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN3.productId);
          break;
        case 4:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN4.productId);
          break;
        default:
          console.log(`Sorry, no offer in cart yet!!`);
      } 
    }
    canceledGifts.step2 = false; 
    localStorage.setItem('step2IsCanceled', false);
  } else if (oldStep == 3) {
    if (cartPromoConditions.step3.offerPos) {
      switch (cartPromoConditions.step3.offerPos) {
        case 1:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN1.productId);
          break;
        case 2:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN2.productId);
          break;
        case 3:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN3.productId);
          break;
        case 4:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN4.productId);
          break;
        default:
          console.log(`Sorry, no offer in cart yet!!`);
      } 
    }
    canceledGifts.step3 = false; 
    localStorage.setItem('step3IsCanceled', false);
  }

  Alpine.store('canceledGiftsInCart', canceledGifts);
}

// disableGiftedProductForStep
async function disableGiftedProductForStep(disable, step) {
  canceledGifts = Alpine.store('canceledGiftsInCart');
  closeSecondLayer();

  if (step == 1) {
    toggleSpiner(true);
    if (cartPromoConditions.step1.offerPos) {
      switch (cartPromoConditions.step1.offerPos) {
        case 1:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN1.productId);
          break;
        case 2:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN2.productId);
          break;
        case 3:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN3.productId);
          break;
        case 4:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN4.productId);
          break;
        default:
          console.log(`Sorry, no offer in cart yet!!`);
      } 
    }
    canceledGifts.step1 = true; 
    localStorage.setItem('step1IsCanceled', true);

    // setTimeout(() => {
      // toggleSpiner(false);
      document.dispatchEvent(
        new CustomEvent("cartupdate", {
          bubbles: false,
          detail: { cart: Alpine.store('cart') },
        }),
      );
    // }, 100);
    
  } else if (step == 2) {
    toggleSpiner(true);
    if (cartPromoConditions.step2.offerPos) {
      switch (cartPromoConditions.step2.offerPos) {
        case 1:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN1.productId);
          break;
        case 2:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN2.productId);
          break;
        case 3:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN3.productId);
          break;
        case 4:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN4.productId);
          break;
        default:
          console.log(`Sorry, no offer in cart yet!!`);
      } 
    }
    canceledGifts.step2 = true;
    localStorage.setItem('step2IsCanceled', true);

    // setTimeout(() => {
      // toggleSpiner(false);
      document.dispatchEvent(
        new CustomEvent("cartupdate", {
          bubbles: false,
          detail: { cart: Alpine.store('cart') },
        }),
      );
    // }, 100);
  } else if (step == 3) {
    toggleSpiner(true);
    if (cartPromoConditions.step3.offerPos) {
      switch (cartPromoConditions.step3.offerPos) {
        case 1:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN1.productId);
          break;
        case 2:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN2.productId);
          break;
        case 3:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN3.productId);
          break;
        case 4:
          await removeGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN4.productId);
          break;
        default:
          console.log(`Sorry, no offer in cart yet!!`);
      } 
    }
    canceledGifts.step3 = true;
    localStorage.setItem('step3IsCanceled', true);

    // setTimeout(() => {
      // toggleSpiner(false);
      document.dispatchEvent(
        new CustomEvent("cartupdate", {
          bubbles: false,
          detail: { cart: Alpine.store('cart') },
        }),
      );
    // }, 100);
  }
  Alpine.store('canceledGiftsInCart', canceledGifts);
}

// cart clear
function clearCart() {
  var formData = {
    'items': []
  };

  return fetch(window.Shopify.routes.root + 'cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json().then(function(json) {

      var freeProducts = { items: [] };  

      Alpine.store('freeProducts', freeProducts);

      cartPromoConditions.step1.offerInCart = false;
      cartPromoConditions.step1.offerPos = false;
      cartPromoConditions.step2.offerInCart = false;
      cartPromoConditions.step2.offerPos = false;
      cartPromoConditions.step3.offerInCart = false;
      cartPromoConditions.step3.offerPos = false;

      // reset gifts cancelation in session
      localStorage.setItem('step1IsCanceled', false);
      localStorage.setItem('step2IsCanceled', false);
      localStorage.setItem('step3IsCanceled', false);

      Alpine.store('canceledGiftsInCart', {
        step1: false,
        step2: false,
        step3: false
      });

      return json;
    });
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function toggleSpiner(show = true) {
  var spiner = document.querySelector('#spiner-cart');
  if (spiner) {
    if (show) {
      spiner.classList.remove('d-none');
      spiner.classList.add('d-flex');
    } else {
      spiner.classList.add('d-none');
      spiner.classList.remove('d-flex');
    }
  }
}

function toggleSpinerSecondLayer(show = true) {
  var spiner = document.querySelector('#spiner-cart-SecondLayer');
  if (spiner) {
    if (show) {
      spiner.classList.remove('d-none');
    } else {
      spiner.classList.add('d-none');
    }
  }
}

function refreshStorewithStorageData() {
  var canceledGiftsInCart = {
    step1: false,
    step2: false,
    step3: false
  };

  if (localStorage.getItem('step1IsCanceled') != null) {
    canceledGiftsInCart.step1 = localStorage.getItem('step1IsCanceled') == 'true'? true : false;
  } else {
    localStorage.setItem('step1IsCanceled', false);
    canceledGiftsInCart.step1 = false;
  }

  if (localStorage.getItem('step2IsCanceled') != null) {
    canceledGiftsInCart.step2 = localStorage.getItem('step2IsCanceled') == 'true'? true : false;
  } else {
    localStorage.setItem('step2IsCanceled', false);
    canceledGiftsInCart.step2 = false;
  }

  if (localStorage.getItem('step3IsCanceled') != null) {
    canceledGiftsInCart.step3 = localStorage.getItem('step3IsCanceled') == 'true'? true : false;
  } else {
    localStorage.setItem('step3IsCanceled', false);
    canceledGiftsInCart.step3 = false;
  }

  Alpine.store('canceledGiftsInCart', canceledGiftsInCart);
}

async function getAvialableGiftForStep(step = '') {
  if (step == '') return;

  if (step == 3) {
    if (
      cartPromoConditions.step3.gift.offerN1  
      && cartPromoConditions.step3.gift.offerN1.productId
    ) {
      await addGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN1.productId);
      cartPromoConditions.step3.offerInCart = true;
      cartPromoConditions.step3.offerPos = 1;
    } else if (
      cartPromoConditions.step3.gift.offerN2 
      && cartPromoConditions.step3.gift.offerN2.productId
    ) {
      await addGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN2.productId);
      cartPromoConditions.step3.offerInCart = true;
      cartPromoConditions.step3.offerPos = 2;
    } else if (
      cartPromoConditions.step3.gift.offerN3 
      && cartPromoConditions.step3.gift.offerN3.productId
    ) {
      await addGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN3.productId);
      cartPromoConditions.step3.offerInCart = true;
      cartPromoConditions.step3.offerPos = 3;
    } else if (
      cartPromoConditions.step3.gift.offerN4 
      && cartPromoConditions.step3.gift.offerN4.productId
    ) {
      await addGiftedProductBasedOnStep(cartPromoConditions.step3.gift.offerN4.productId);
      cartPromoConditions.step3.offerInCart = true;
      cartPromoConditions.step3.offerPos = 4;
    }
  } else if (step == 2) {
    if (
      cartPromoConditions.step2.gift.offerN1  
      && cartPromoConditions.step2.gift.offerN1.productId
    ) {
      await addGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN1.productId);
      cartPromoConditions.step2.offerInCart = true;
      cartPromoConditions.step2.offerPos = 1;
    } else if (
      cartPromoConditions.step2.gift.offerN2 
      && cartPromoConditions.step2.gift.offerN2.productId
    ) {
      await addGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN2.productId);
      cartPromoConditions.step2.offerInCart = true;
      cartPromoConditions.step2.offerPos = 2;
    } else if (
      cartPromoConditions.step2.gift.offerN3 
      && cartPromoConditions.step2.gift.offerN3.productId
    ) {
      await addGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN3.productId);
      cartPromoConditions.step2.offerInCart = true;
      cartPromoConditions.step2.offerPos = 3;
    } else if (
      cartPromoConditions.step2.gift.offerN4 
      && cartPromoConditions.step2.gift.offerN4.productId
    ) {
      await addGiftedProductBasedOnStep(cartPromoConditions.step2.gift.offerN4.productId);
      cartPromoConditions.step2.offerInCart = true;
      cartPromoConditions.step2.offerPos = 4;
    }
  } else if (step == 1) {
    if (
      cartPromoConditions.step1.gift.offerN1  
      && cartPromoConditions.step1.gift.offerN1.productId
    ) {
      await addGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN1.productId);
      cartPromoConditions.step1.offerInCart = true;
      cartPromoConditions.step1.offerPos = 1;
    } else if (
      cartPromoConditions.step1.gift.offerN2 
      && cartPromoConditions.step1.gift.offerN2.productId
    ) {
      await addGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN2.productId);
      cartPromoConditions.step1.offerInCart = true;
      cartPromoConditions.step1.offerPos = 2;
    } else if (
      cartPromoConditions.step1.gift.offerN1 
      && cartPromoConditions.step1.gift.offerN1.productId
    ) {
      await addGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN1.productId);
      cartPromoConditions.step1.offerInCart = true;
      cartPromoConditions.step1.offerPos = 1;
    } else if (
      cartPromoConditions.step1.gift.offerN4 
      && cartPromoConditions.step1.gift.offerN4.productId
    ) {
      await addGiftedProductBasedOnStep(cartPromoConditions.step1.gift.offerN4.productId);
      cartPromoConditions.step1.offerInCart = true;
      cartPromoConditions.step1.offerPos = 4;
    }
  }
}

async function addGiftForStep1() {
  if (cartPromoConditions.step1.type == 'product') {
    // apply gift based on the progress of cart
    if (
      (!Alpine.store('canceledGiftsInCart').step1) &&
      !checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN1.productId) && 
      !checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN2.productId) && 
      !checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN3.productId) && 
      !checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN4.productId) && 
      cartPromoConditions.step1.offerInCart == false && 
      cartPromoConditions.step1.offerPos == false
    ) {
      await getAvialableGiftForStep(1);
    }
    // check if gift already in cart 
    if (checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN1.productId)) {
      cartPromoConditions.step1.offerInCart = true;
      cartPromoConditions.step1.offerPos = 1;
    } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN2.productId)) {
      cartPromoConditions.step1.offerInCart = true;
      cartPromoConditions.step1.offerPos = 2;
    } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN3.productId)) {
      cartPromoConditions.step1.offerInCart = true;
      cartPromoConditions.step1.offerPos = 3;
    } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step1.gift.offerN4.productId)) {
      cartPromoConditions.step1.offerInCart = true;
      cartPromoConditions.step1.offerPos = 4;
    }
  }
}
async function addGiftForStep2() {
  if (cartPromoConditions.step2.type == 'product') {
    // apply gift based on the progress of cart
    if (
      (!Alpine.store('canceledGiftsInCart').step2) &&
      !checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN1.productId) && 
      !checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN2.productId) && 
      !checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN3.productId) && 
      !checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN4.productId) &&
      cartPromoConditions.step2.offerInCart == false && 
      cartPromoConditions.step2.offerPos == false
    ) {
      await getAvialableGiftForStep(2);
    }
    // check if gift already in cart 
    if (checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN1.productId)) {
      cartPromoConditions.step2.offerInCart = true;
      cartPromoConditions.step2.offerPos = 1;
    } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN2.productId)) {
      cartPromoConditions.step2.offerInCart = true;
      cartPromoConditions.step2.offerPos = 2;
    } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN3.productId)) {
      cartPromoConditions.step2.offerInCart = true;
      cartPromoConditions.step2.offerPos = 3;
    } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step2.gift.offerN4.productId)) {
      cartPromoConditions.step2.offerInCart = true;
      cartPromoConditions.step2.offerPos = 4;
    }
  }
}
async function addGiftForStep3() {
  if (cartPromoConditions.step3.type == 'product') {
    if (
      (!Alpine.store('canceledGiftsInCart').step3) && 
      !checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN1.productId) && 
      !checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN2.productId) && 
      !checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN3.productId) && 
      !checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN4.productId) && 
      cartPromoConditions.step3.offerInCart == false && 
      cartPromoConditions.step3.offerPos == false
    ) {
      if (cartPromoConditions.step3.gift) {
        await getAvialableGiftForStep(3);
      }
    }
    // check if gift already in cart 
    if (checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN1.productId)) {
      cartPromoConditions.step3.offerInCart = true;
      cartPromoConditions.step3.offerPos = 1;
    } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN2.productId)) {
      cartPromoConditions.step3.offerInCart = true;
      cartPromoConditions.step3.offerPos = 2;
    } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN3.productId)) {
      cartPromoConditions.step3.offerInCart = true;
      cartPromoConditions.step3.offerPos = 3;
    } else if (checkIfProductExistInCartAsGift(cartPromoConditions.step3.gift.offerN4.productId)) {
      cartPromoConditions.step3.offerInCart = true;
      cartPromoConditions.step3.offerPos = 4;
    }
  }
}

function closeSecondLayer() {
  $('#minicart #left').fadeIn();
  $('#firstLayer').fadeIn();
  $('#topFirstLayer').fadeIn();
  $('#secondLayer-s1').hide();
  $('#secondLayer-s2').hide();
  $('#secondLayer-s3').hide();
  $('#topSecondlayer-s1').hide();
  $('#topSecondlayer-s2').hide();
  $('#topSecondlayer-s3').hide();
  $('#minicart #right').addClass('border-start')
  $('.slick').slick('refresh');
}

function refreshCart() {
  toggleSpiner(true);
  setTimeout(() => {
    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      return response.json().then(function(cart) {
        Alpine.store('cart', cart);
        checkExestingGiftsInCart();
        calculateProgress();
        refreshStorewithStorageData();
        extractFreeProductsInCart();
      });
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }, 300);

  setTimeout(() => {
    toggleSpiner(false);
  }, 300);
}

async function updateCartStore() {
  // async awiat
  await fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => {
    return response.json().then(function(cart) {
      Alpine.store('cart', cart);
    });
  })
  .catch((error) => {
    console.error('Error:', error);
    return false;
  });

  checkExestingGiftsInCart();
  await calculateProgress();
  extractFreeProductsInCart();

  document.dispatchEvent(
    new CustomEvent("cartupdate", {
      bubbles: false,
      detail: { cart: Alpine.store('cart') },
    }),
  );
}

function miniAddToCart(variant_id, quantity) { 
  event.preventDefault();
  if (!variant_id || !quantity) return;
  
  var formData = {
    'items': [{
     'id': variant_id,
     'quantity': quantity
    }]
  };

  toggleSpiner(true);
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json().then(function(json) {
      fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        return response.json().then(function(cart) {
          Alpine.store('cart', cart);
          checkExestingGiftsInCart();
          calculateProgress();
          extractFreeProductsInCart();

          document.dispatchEvent(
            new CustomEvent("cartupdate", {
              bubbles: false,
              detail: { cart: cart },
            }),
          );
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });
  })
  .catch((error) => {
    console.error('Error:', error);
  });  
}
// end